(function () {
  var windowWidth = window.innerWidth
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	window.addEventListener('resize', function () {
    console.log('resize', windowWidth, window.innerWidth)
    if (windowWidth !== window.innerWidth) {
      $('.product-section .js-media-list').each(function () {
        this.swiper.destroy();
      });
      $('.product-section .js-media-sublist').each(function () {
        this.swiper.destroy();
      });

      swiperInit();
      windowWidth = window.innerWidth
    }
	});

	swiperInit();
})();
